import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ar from './locales/ar.json';
import nl from './locales/nl.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import de from './locales/de.json';
import it from './locales/it.json';
import ru from './locales/ru.json';
import tr from './locales/tr.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  nl: { translation: nl },
  fr: { translation: fr },
  es: { translation: es },
  de: { translation: de },
  it: { translation: it },
  ru: { translation: ru },
  tr: { translation: tr },
} as const;

const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('kalimat-language');
    if (stored) return stored;

    const navLang = navigator.language?.split('-')?.[0];
    if (navLang && Object.prototype.hasOwnProperty.call(resources, navLang)) {
      return navLang;
    }
  }
  return 'en';
};

const applyDir = (lng: string) => {
  if (typeof document === 'undefined') return;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
};

const initialLanguage = getInitialLanguage();
applyDir(initialLanguage);

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('kalimat-language', lng);
  } catch {
    // ignore
  }
  applyDir(lng);
});

export default i18n;
